<header class="app-header">
    <div class="header-logo">
        <img src="./assets/images/logo-ivsw.svg" alt="Logo IVSW" />
    </div>
    <button nz-button (click)="logout()">{{ "common.logout" | translate }}</button>
</header>